import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative px-0 py-10 lg:p-10 w-full min-h-screen" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "block lg:hidden h-8 mw-40 mb-6",
  src: "/media/logos/logo-full-dark.svg",
  alt: "Logo"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "block p-6 rounded-md shadow-sm bg-white mb-4 max-w-5xl" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-xl leading-7 font-medium mb-3" }, " Success! "),
  /*#__PURE__*/_createElementVNode("p", { class: "text-base max-w-xl" }, "We've sent a verification email to your inbox. Please click the link to log in, update your credit box, and review the terms and conditions.")
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}